
export interface Good {
  id: number,
  name: string,
  image: File,
  isIMO?: boolean,
  sku: string,
}

export interface GoodCreate {
  name: string,
  image: File,
  isIMO: boolean
  sku: string,
}
